webpackJsonp([89546000380666],{

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.servicesPageQuery = exports.ServicesPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(11);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(8);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Team = __webpack_require__(16);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _ResourceList = __webpack_require__(18);
	
	var _ResourceList2 = _interopRequireDefault(_ResourceList);
	
	var _Contact = __webpack_require__(12);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesPageTemplate = exports.ServicesPageTemplate = function ServicesPageTemplate(_ref) {
	    var title = _ref.title,
	        headerImage = _ref.headerImage,
	        headerTitle = _ref.headerTitle,
	        content = _ref.content,
	        contentComponent = _ref.contentComponent;
	
	    var PageContent = contentComponent || _Content2.default;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	            title: "San Juan Software | " + headerTitle
	        }),
	        _react2.default.createElement(
	            'section',
	            { className: 'hero header-image-hero sub-page-hero services-page-hero' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body', style: { backgroundImage: 'url(' + headerImage + ')' } },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'title' },
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'type-it' },
	                        headerTitle
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement('section', { className: 'hero hero-bar is-primary' }),
	        _react2.default.createElement(
	            'section',
	            { className: 'section content section--gradient' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-10 is-offset-1' },
	                        _react2.default.createElement(PageContent, { className: 'services-content', content: content })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { id: 'iot', className: 'section content is-sjs-white-smoke' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-8' },
	                        _react2.default.createElement('img', { style: { float: 'right' }, src: '/img/services/iStock-824198232.jpg' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-4' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Sensor and Control Networks'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We know the specifications, stacks and tools because we have used them, implemented them and even helped to create them. Since 2004, San Juan Software has taken various leadership roles in the Zigbee Alliance. We have written and collaborated on stacks and application profiles for semiconductor companies. We have implemented a wide variety of wired and wireless protocols for the IoT including Wi-Fi, BLE, Thread and more on a wide array of platforms.'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-4', style: { textAlign: 'right' } },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Cloud Services'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We can help you with cloud services on AWS and Azure. Fog Computing brings more intelligence to the local network for faster response and greater reliability. Even when internet connections are down, data can be aggregated, then uploaded and analyzed later for improved predictability and secure data storage.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-8' },
	                        _react2.default.createElement('img', { src: '/img/services/iStock-846400236.jpg' })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { id: 'aerospace', className: 'section content is-sjs-white-smoke' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-8' },
	                        _react2.default.createElement('img', { style: { float: 'right' }, src: '/img/services/iStock-181929384.jpg' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-4' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Aerospace'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Our engineering team has extensive experience in adding IoT solutions in aerospace. Whether it\u2019s managing Software Lifecycle Data for DO178C compliance or using ARINC 429, 717, ACARS and other communications protocols, we have the skills and experience to bring your products to market.'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-4', style: { textAlign: 'right' } },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Design Review and Consulting'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Our team can discuss your product idea, suggest hardware features that might be helpful or suggest ways to cut costs and point out other considerations prior to locking in product designs.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-8' },
	                        _react2.default.createElement('img', { src: '/img/services/iStock-853569438.jpg' })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section content is-sjs-white-smoke' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-8' },
	                        _react2.default.createElement('img', { style: { float: 'right' }, src: '/img/services/iStock-664035872.jpg' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-4' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Software Engineering'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'With many years of low-level and embedded software experience, the experts at San Juan Software can meet your IoT software application development challenges, save you money, reduce the learning curve and help you get the right product to market faster.'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-4', style: { textAlign: 'right' } },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Firmware Engineering'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We have expertise with bootloaders, low power, and over-the-air updates. We have an integrated team of CS and EE engineers for board bring up and other firmware needs.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-8' },
	                        _react2.default.createElement('img', { src: '/img/services/iStock-475612880.jpg' })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section content is-sjs-white-smoke' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-8' },
	                        _react2.default.createElement('img', { style: { float: 'right' }, src: '/img/services/iStock-898686628.jpg' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-4' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Test and Verification'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Our engineers can scope, implement and run a test and verification plan based on your market expectations, certification needs and other factors, to give you sufficient coverage. With access to test suites and harnesses available only to members of the standards organizations, much of the work may already be done.'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-4', style: { textAlign: 'right' } },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'We Ask Why'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'San Juan Software takes the time to understand the "why" in your product specifications, ensuring you get exactly the solution you need, with emphasis on the aspects important to you. We develop a proposal designed specifically to suit your needs for each project, and pride ourselves in completing the work in a quality and timely manner. San Juan Software can work with you in finding the best solution to fit your needs in terms of cost, schedule or features.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-8' },
	                        _react2.default.createElement('img', { src: '/img/services/iStock-476562658.jpg' })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section content is-sjs-white-smoke' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-8' },
	                        _react2.default.createElement('img', { style: { float: 'right' }, src: '/img/services/iStock-625736338.jpg' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-4' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Part of Your Team'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Companies all over the world are being challenged to do more with fewer resources. By focusing on your core functions and sourcing software development services from San Juan Software you can reduce risk, add value and improve your time-to-revenue.'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { id: 'our-customers', className: 'section content is-sjs-dark-blue' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-12' },
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'title' },
	                            'What Our Customers Are Saying'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card is-sjs-white' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-content' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'title' },
	                                    '\u201CSan Juan Software\u2019s engineer was able to take our development source code and within a few weeks most of the issues were resolved. The end result was we had an efficient high density network structure that could handle the hundreds of routers and hundreds more endpoints\u2026exactly what we were looking for.\u201D'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'em',
	                                        null,
	                                        '\u2014 Mike Mahoney, IgeaCare Solutions Inc.'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card is-sjs-white' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-content' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'title' },
	                                    '\u201CBecause of their strong industry connections and experience, San Juan Software were able to overcome a number of deep bugs that would have been showstoppers for us. We have been very pleased with their professionalism / quality and work very well with them.\u201D'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'em',
	                                        null,
	                                        '\u2014 Jun Shimada, ThinkEco, Inc.'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card is-sjs-white' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-content' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'title' },
	                                    '\u201CThe team at San Juan Software is great at identifying needs, scoping out the project and meeting deadlines. I would definitely work with them again.\u201D'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'em',
	                                        null,
	                                        '\u2014 Andrew Poliak, Vice President, Panasonic'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card is-sjs-white' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-content' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'title' },
	                                    '\u201CFor more than 10 years, [the Management Team at San Juan Software] have been always listening to the requirements in Japan and helped us with their outstanding creativity in both technology and business sense.\u201D'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'em',
	                                        null,
	                                        '\u2014 Hiro Kato, President, A.I.Corporation'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_Contact2.default, null)
	    );
	};
	
	exports.default = function (_ref2) {
	    var data = _ref2.data;
	    var _data$markdownRemark = data.markdownRemark,
	        frontmatter = _data$markdownRemark.frontmatter,
	        html = _data$markdownRemark.html;
	
	
	    return _react2.default.createElement(ServicesPageTemplate, {
	        contentComponent: _Content.HTMLContent,
	        title: frontmatter.title,
	        headerImage: frontmatter.headerImage,
	        headerTitle: frontmatter.headerTitle,
	        content: html
	    });
	};
	
	var servicesPageQuery = exports.servicesPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-services-page-js-2532ec53510df40892e3.js